import {
  Badge,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Heading,
  Img,
  Input,
  Switch,
  Text,
  Textarea,
  VStack,
  useToast
} from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import generic from '@service/generic'

function toDatetimeLocal(value: string | null | undefined): string {
  if (!value) return ''
  if (/^\d{2}:\d{2}(:\d{2})?$/.test(value.trim())) return ''
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}`
}

const AdminManutencao: FC = () => {
  const toast = useToast()
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [ativo, setAtivo] = useState(false)
  const [motivo, setMotivo] = useState('')
  const [previsao, setPrevisao] = useState('')

  useEffect(() => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        setAtivo(data.valor === 'true')
        setMotivo(data.motivo ?? '')
        setPrevisao(toDatetimeLocal(data.previsao))
      })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  const handleSave = () => {
    setSaving(true)
    generic
      .putMaintence({
        Ativo: ativo,
        Motivo: ativo && motivo ? motivo : null,
        Previsao: ativo && previsao ? new Date(previsao).toISOString() : null
      })
      .then(() => {
        toast({
          title: 'Configuração salva com sucesso.',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right'
        })
      })
      .catch(() => {
        toast({
          title: 'Erro ao salvar configuração.',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right'
        })
      })
      .finally(() => setSaving(false))
  }

  return (
    <>
      <Helmet>
        <title>Admin - Manutenção - SCL</title>
      </Helmet>
      <Box bg="green.600" h="100vh" overflowY="auto">
        <Flex
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          minH="100vh"
          p={6}
        >
          <Img
            src="/assets/images/maintence.png"
            width={['40%', '30%', '15%']}
            mb={4}
          />
          <Heading
            fontSize={['28px', '32px', '38px']}
            fontWeight="800"
            color="white"
            mb={6}
          >
            SCL — Painel de Manutenção
          </Heading>

          <Box
            bg="white"
            borderRadius="16px"
            p={8}
            w="100%"
            maxW="520px"
            boxShadow="xl"
          >
            <HStack justifyContent="space-between" mb={6}>
              <Heading size="md" color="gray.700">
                Configurar Manutenção
              </Heading>
              <Badge
                colorScheme={ativo ? 'red' : 'green'}
                fontSize="xs"
                px={3}
                py={1}
                borderRadius="full"
              >
                {ativo ? 'Em Manutenção' : 'Operacional'}
              </Badge>
            </HStack>

            <VStack spacing={5} align="stretch">
              <FormControl display="flex" alignItems="center" gap={3}>
                <Switch
                  id="ativo-switch"
                  colorScheme="red"
                  isChecked={ativo}
                  onChange={e => setAtivo(e.target.checked)}
                  size="lg"
                />
                <FormLabel
                  htmlFor="ativo-switch"
                  mb={0}
                  fontWeight="600"
                  color="gray.700"
                >
                  {ativo ? 'Manutenção ativa' : 'Manutenção inativa'}
                </FormLabel>
              </FormControl>

              <FormControl isDisabled={!ativo}>
                <FormLabel fontWeight="600" color="gray.600" fontSize="sm">
                  Motivo
                </FormLabel>
                <Textarea
                  placeholder="Descreva o motivo da manutenção..."
                  value={motivo}
                  onChange={e => setMotivo(e.target.value)}
                  resize="vertical"
                  rows={3}
                  borderColor="gray.300"
                  focusBorderColor="green.500"
                  fontSize="sm"
                />
              </FormControl>

              <FormControl isDisabled={!ativo}>
                <FormLabel fontWeight="600" color="gray.600" fontSize="sm">
                  Previsão de Normalização
                </FormLabel>
                <Input
                  type="datetime-local"
                  value={previsao}
                  onChange={e => setPrevisao(e.target.value)}
                  borderColor="gray.300"
                  focusBorderColor="green.500"
                  fontSize="sm"
                />
              </FormControl>

              <Button
                colorScheme="green"
                onClick={handleSave}
                isLoading={saving}
                isDisabled={loading}
                size="md"
                w="100%"
                mt={2}
              >
                Salvar
              </Button>
            </VStack>
          </Box>

          <Text fontSize="xs" color="green.200" mt={6}>
            Acesso restrito — apenas administradores
          </Text>
        </Flex>
      </Box>
    </>
  )
}

export default AdminManutencao
